// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__qa4DM","ellipsis":"styles_ellipsis__E3zxR","text2AndMoreLines":"styles_text2AndMoreLines__2szfs","tooltipTrigger":"styles_tooltipTrigger__tTGGK"};